import { SDKAggregator } from '@mc-alberta/sdk-aggregator'

export function getInstance () {
  if (!window.sdkManager) {
    window.sdkManager = new SDKAggregator({
      config: {
        sdks: {
          loadTimeoutMs: 20000 // overrides SDK load timeout
        }
      }
    })
  }
  if (!window.opener) {
    return window.sdkManager
  } else {
    return window.opener.sdkManager
  }
}
